import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { UAParser } from 'ua-parser-js';
import { OcrModes, recognizeText } from '../actions/OcrAction';
import { l10n } from '../i18n/Localization';
import GameCode from '../models/games/GameCode';
import BackButton from './BackButton';

class OcrPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            canRecognize: false,
            recognizeTextStarted: false,
        };

        this.imageObjectUrl = null;
        this.refImage = React.createRef();
    }

    _getCanLaunchCameraApp() {
        const uaParser = new UAParser();
        const deviceType = uaParser.getDevice().type;

        if (deviceType === 'mobile' || deviceType === 'tablet') {
            return true;
        } else {
            return false;
        }
    }

    handleFileInputOnChange = (event) => {
        if (event.target.files.length > 0) {
            const imageFile = event.target.files[0];

            this.imageObjectUrl = URL.createObjectURL(imageFile);
            this.refImage.current.src = this.imageObjectUrl;

            this.setState({
                canRecognize: false,
            });
        }
    }

    handleImageOnLoad = () => {
        if (this.imageObjectUrl !== null) {
            URL.revokeObjectURL(this.imageObjectUrl);
            this.imageObjectUrl = null;

            this.setState({
                canRecognize: true,
            });
        }
    }

    _recognizeText(canvas) {
        this.setState({
            recognizeTextStarted: true,
        });

        this.props.recognizeText(canvas);
    }

    recognizeTextFromImage = () => {
        if (this.refImage.current.complete === false) {
            return;
        }

        const canvas = document.createElement('canvas');

        canvas.width = this.refImage.current.naturalWidth;
        canvas.height = this.refImage.current.naturalHeight;

        const context = canvas.getContext('2d');

        context.drawImage(this.refImage.current, 0, 0);

        this._recognizeText(canvas);
    }

    render() {
        const { recognizeTextCompleted, recognizeTextError } = this.props;
        const { canRecognize, recognizeTextStarted } = this.state;

        if (recognizeTextStarted && recognizeTextCompleted && recognizeTextError === null) {
            return <Redirect to="/characters/identify" />;
        }

        let recognizeTextHint;
        let isRecognizing;

        if (recognizeTextStarted) {
            if (recognizeTextCompleted) {
                recognizeTextHint = (recognizeTextError !== null) ? recognizeTextError.message : '';
                isRecognizing = false;
            } else {
                recognizeTextHint = '';
                isRecognizing = true;
            }
        } else {
            recognizeTextHint = '';
            isRecognizing = false;
        }

        const canLaunchCameraApp = this._getCanLaunchCameraApp();
        const actionDiv = (
            <div>
                <div className="d-flex justify-content-center align-items-center mb-3">
                    <label className={`btn btn-primary${isRecognizing ? ' disabled' : ''}`} htmlFor="file_input">{canLaunchCameraApp ? l10n.ocrPage.launchCameraApp : l10n.ocrPage.pickImageFile}</label>
                    <input id="file_input" className="d-none" type="file" accept="image/*" capture="environment" onChange={this.handleFileInputOnChange} disabled={isRecognizing} />
                </div>
                {
                    canRecognize ? (
                        <div className="text-center text-success mb-3">{l10n.ocrPage.targetTextHint.replace('{targetTextName}', l10n.ocrPage.characterName)}</div>
                    ) : null
                }
                <div className="d-flex justify-content-center mb-3">
                    {isRecognizing ? <div className="spinner-border mr-1"></div> : null}
                </div>
                <div className="text-center mb-3">{recognizeTextHint}</div>
                <div className="d-flex justify-content-center">
                    <button className="btn btn-primary" type="button" onClick={this.recognizeTextFromImage} disabled={!canRecognize || isRecognizing}>{l10n.action.startScanning}</button>
                </div>
            </div>
        );

        const content = (
            <div className="container mt-3">
                <div className="d-flex justify-content-between mb-3">
                    <BackButton disabled={!recognizeTextCompleted} />
                </div>
                <div className="row justify-content-center mb-3">
                    <div className="col-6">
                        <div className={`embed-responsive embed-responsive-4by3${canRecognize ? '' : ' d-none'}`}>
                            <img ref={this.refImage} className="embed-responsive-item img-contain" onLoad={this.handleImageOnLoad} alt={l10n.ocrPage.imageForOcr}></img>
                        </div>
                    </div>
                </div>
                {actionDiv}
            </div>
        );

        return (
            <div className="OcrPage">
                <Helmet>
                    <link rel="icon" type="image/x-icon" href={`${process.env.PUBLIC_URL}/favicon.ico`} />
                    <meta name="description" content={l10n.ocrPage.pageTitle} />
                    <title>{l10n.ocrPage.pageTitle} - {l10n.productName}</title>
                </Helmet>
                {content}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        gameCode: GameCode.starcraft2,
        targetText: l10n.ocrPage.characterName,
        recognizeTextCompleted: state.ocrState.recognizeTextCompleted,
        recognizeTextError: state.ocrState.recognizeTextError,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        recognizeText: (canvas) => {
            dispatch(recognizeText(canvas, OcrModes.UpperMiddleLine));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OcrPage);
